import React from "react";

import { clsx } from "clsx";

import { StyledButtonLink } from "../../Styled/Button";

import { IconVintageArrow } from "@bared/ui";

const Button = (props: any) => (
  <StyledButtonLink
    {...props}
    className={clsx(
      props.className,
      "pointer-events-auto z-10 w-full md:max-w-[300px]",
      props.mobile
        ? "flex border-l border-r border-neutral bg-neutral-alt md:hidden"
        : "hidden md:flex",
    )}
  />
);

const HeroButton = ({ children, className, link, mobile }) => (
  <Button
    className={`group ${className}`}
    colour="light"
    height="88-56"
    textSize="32"
    mobile={mobile}
    to={link}
    icon
  >
    {children}
    <IconVintageArrow
      direction="right"
      className="duration-slow w-[48px] pl-micro transition-transform group-hover:translate-x-pico group-hover:transform"
    />
  </Button>
);

export default HeroButton;
